import { textColor, textSm } from '@insify/design-system/typography';
import clsx from 'clsx';
import { forwardRef } from 'react';

import * as styles from './IconList.module.css';

import type { LegacyRef } from 'react';

export type IconListItem = {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  Body: React.ComponentType;
};

type IconListProps = {
  id?: string;
  kind: 'small' | 'big';
  list: IconListItem[];
  className?: string;
};

// export const IconList: React.FC<IconListProps> = forwardRef(
export const IconList = forwardRef<HTMLUListElement | HTMLDivElement, IconListProps>(
  ({ kind, list, className, id }, ref): JSX.Element => (
    <ul id={id} ref={ref as LegacyRef<HTMLUListElement>} className={clsx(styles.list, styles[kind], className)}>
      {list.map(({ Icon, Body }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li className={styles.item} key={index}>
          <Icon className={styles.icon} />
          <div className={clsx(textSm, textColor, styles.bodyContainer, 'notranslate')}>
            <Body />
          </div>
        </li>
      ))}
    </ul>
  ),
);
